import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional class names, with later Tailwind utilities beating earlier ones.
 *
 * Plain concatenation does not work with Tailwind: `"p-2 p-4"` leaves both in
 * the class list, and the winner is whichever rule sits later in the generated
 * stylesheet - not the one written last. twMerge knows which utilities conflict
 * and drops the loser.
 *
 * That is what lets a component's `className` prop reliably override the
 * component's own defaults.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
